export interface ChatbotConfig {
    key: string;
    main: string;
    startup: string;
    styles: string;
}

export const chatbotConfig: ChatbotConfig = {
    key: 'dec62908-e81e-41a7-a2ff-6296d49cff59',
    main: '/libs/dx-chatbot-ui/browser/main.js',
    startup: '/libs/dx-chatbot-ui/browser/assets/startup/startup.json',
    styles: '/libs/dx-chatbot-ui/browser/styles.css'
};
